"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var storybook_2 = require("@eyecons/storybook");
var icons = {
    success: {
        className: 'text-green-500',
        icon: 'check-circle',
    },
    warning: {
        className: 'text-primary',
        icon: 'exclamation',
    },
    danger: {
        className: 'text-red-500',
        icon: 'exclamation-shield',
    },
};
var Body = function (_a) {
    var title = _a.title, description = _a.description, type = _a.type, image = _a.image, link = _a.link;
    return react_1.default.createElement(react_1.default.Fragment, null,
        type &&
            react_1.default.createElement(storybook_2.Icons.Icon, { className: icons[type].className + " storybook-notifications-icon", name: icons[type].icon }),
        Boolean(image) && react_1.default.createElement(storybook_1.Notifications.Image, { src: image }),
        react_1.default.createElement("div", { className: 'storybook-notifications-content' },
            Boolean(title) && react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h4' }, title),
            Boolean(description) && react_1.default.createElement(storybook_1.Texts.Primary, null, description),
            link && react_1.default.createElement(storybook_1.Texts.Link, { target: link.target || '', href: link.href }, link.label)));
};
var Close = function (_a) {
    var onClose = _a.onClose;
    return react_1.default.createElement("div", { className: 'storybook-notifications-close' },
        react_1.default.createElement(storybook_1.Buttons.Button, { onClick: onClose },
            react_1.default.createElement(storybook_2.Icons.Icon, { className: "storybook-notifications-close", name: 'x' })));
};
var Notification = function (_a) {
    var id = _a.id, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, type = _a.type, title = _a.title, description = _a.description, onClose = _a.onClose, open = _a.open, image = _a.image, link = _a.link;
    var style = 'storybook-notifications-notification';
    if (type) {
        style = style + " storybook-notifications-" + type;
    }
    if (!open) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement("div", { id: id, className: className || style },
        react_1.default.createElement("div", { className: 'storybook-notifications-body' },
            children ? children : react_1.default.createElement(Body, { title: title, description: description, type: type, image: image, link: link }),
            onClose && react_1.default.createElement(Close, { onClose: onClose })));
};
exports.Notification = Notification;
exports.Notification.propTypes = {
    /**
     * The id of the List
     */
    id: prop_types_1.default.string,
    /**
     * Use a different classname
     */
    className: prop_types_1.default.string,
    /**
     * Add more classnames
     */
    appendClassname: prop_types_1.default.string,
    /**
     * The open state of the notfication
     */
    open: prop_types_1.default.bool,
    /**
     * On close event
     */
    onClose: prop_types_1.default.func,
    /**
     * The type of Notification
     */
    type: prop_types_1.default.oneOf(['default', 'success', 'warning', 'danger']),
    image: prop_types_1.default.string,
    link: prop_types_1.default.shape({
        label: prop_types_1.default.string.isRequired,
        href: prop_types_1.default.string.isRequired,
        target: prop_types_1.default.oneOf(['_blank']),
    }),
};
exports.Notification.defaultProps = {
    appendClassname: '',
};
